import type { Immutable } from "immer";
import React from "react";
import { IovationScripts } from "tsi-common-react/src/components/IovationScripts/index";

import { Context, templates } from "@reactivated";

import { Template as WriteReview } from "../../templates/WriteReviewTemplate";

import styles from "./index.module.scss";

export const WriteReviewPageBody = (
    props: Immutable<
        Omit<templates.WriteReviewPageDocumentTemplate, "page_chrome">
    >,
): React.JSX.Element => {
    const chrome = React.useContext(Context).chrome;
    return (
        <section className={styles.writeReview}>
            <div className="main-container">
                <div className={styles.newReviewIntro}>
                    <h1>WHAT DO YOU THINK?</h1>
                </div>
                <div className="customer-review__header">
                    <WriteReview
                        brand_id={props.brand_id}
                        return_url={props.return_url}
                        products_data={props.products_data}
                        review_template_data={props.review_template_data}
                    />
                </div>
            </div>
            <IovationScripts
                iovationUrl={props.iovation_url}
                staticBase={chrome.static_base}
            />
        </section>
    );
};
